import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    title: 'subtitle-2 timberland:!subtitle-3 fw-bold',
    shopAll: 'py-2 uppercase underlined not-only-child:(b-b b-grey-70)'
  }
} satisfies CMSConfig['megaMenuL1Mobile']
